module.exports = __webpack_public_path__ + "media/mare-nostrum-shanty-crew.1969f5ae.mp4";